import { Button } from 'primereact/button';
import { ToastService, useDataTable, useDialogCrup } from '@iamsoftware/react-hooks';
import { AgreementConfigService as Service } from '../../../service/AgreementConfigService';

export const OrganizationRoles = () => {
    const dataKey = 'roleTypeId';
    const header = 'Danh sách vai trò ký';

    const tableHeader = (
        <div className="flex align-items-center justify-content-between">
            <span>{header}</span>
            <div>
                <Button label="Thêm" icon="pi pi-plus" severity="success" className="mr-1 mb-1 w-7rem h-2rem" size="small" onClick={() => doCreate()} />
            </div>
        </div>
    );

    const { render: renderDataTable, reloadLazyData } = useDataTable({
        tableHeader: tableHeader,
        dataKey,
        indexColumnWidth: 45,
        columns: [
            { field: 'roleTypeId', header: 'Mã vai trò', minWidth: 100, matchMode: "contains" },
            { field: 'description', header: 'Tên vai trò (Mô tả)', minWidth: 250, matchMode: "contains" },
        ],
        actionColumnWidth: 100,
        getList(lazyLoadEvent: any): Promise<any> {
            return Service.getRoles(lazyLoadEvent);
        },
        initActions(items: Array<any>) {
            if (items) {
                items.forEach(item => {
                    const isSystem = !item.ownerPartyId;
                    item.actions = [];

                    if (!isSystem) {
                        item.actions.push(
                            { icon: 'pi pi-pencil', title: 'Chỉnh sửa', className: 'p-button-info', command: () => doUpdate(item) }
                        );
                    }
                });
            }
        },
        originalProps: { scrollHeight: 'calc(100vh - 300px)' }
    });

    const { render: renderDialogCrup, update, create, form } = useDialogCrup({
        header: 'vai trò ký',
        dataKey,
        width: '30rem',
        fields: [
            { field: 'description', header: 'Tên vai trò (Mô tả)', required: true, className: 'md:col-12' },
        ],
        async createItem(item: any): Promise<any> {
            try {
                const resp = await Service.createRole(item);
                if (resp && resp.success === 'Y') {
                    ToastService.success();
                    reloadLazyData();
                    return resp;
                } else {
                    const msg = resp?.error || 'Tạo vai trò thất bại';
                    ToastService.error(msg);
                    return Promise.reject(msg);
                }
            } catch (error) {
                ToastService.error(error);
                return Promise.reject(error);
            }

        },
        async updateItem(id: string, item: any): Promise<any> {
            try {
                const resp = await Service.updateRole(id, item);
                if (resp && resp.success === 'Y') {
                    ToastService.success();
                    reloadLazyData();
                    return resp;
                } else {
                    const msg = resp?.error || 'Cập nhật vai trò thất bại';
                    ToastService.error(msg);
                    return Promise.reject(msg)  ;
                }
            } catch (error) {
                ToastService.error(error);
                return Promise.reject(error);
            }
        },
        reloadLazyData,
    });

    const doCreate = () => {
        create();
    };

    const doUpdate = (item: any) => {
        update(item);
    };

    const doView = (item: any) => {
        // useDialogCrup.view is not used as we don't have view button anymore for custom roles, 
        // but for system roles we still use it.
    };

    return (
        <div className="card border-none shadow-1 border-round-xl" style={{ backgroundColor: 'var(--surface-ground)' }}>
            <style dangerouslySetInnerHTML={{
                __html: `
                .vai-tro-table .p-datatable-thead > tr:first-child > th {
                    position: sticky !important; top: 0 !important; z-index: 10 !important;
                    background: var(--surface-card) !important;
                }
                .vai-tro-table .p-datatable-thead > tr:nth-child(2) > th {
                    position: sticky !important; top: 38px !important; z-index: 9 !important;
                    background: var(--surface-card) !important;
                }
            `}} />
            <div className="col-12">
                <h3 className="m-0 mb-2" style={{ color: 'var(--text-color)', fontWeight: 'bold' }}>{header}</h3>
            </div>
            <div className="col-12 py-0 vai-tro-table">
                {renderDataTable()}
            </div>
            {renderDialogCrup()}
        </div>
    );
};
